import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Stack,
  TextField,
  Button,
  Avatar,
  Chip,
  Grid
} from '@mui/material';
import { Send as SendIcon } from '@mui/icons-material';
import { Event } from '@/types/events';

interface TeamCollaborationProps {
  event: Event;
  onUpdate: (updatedEvent: Event) => void;
}

export const TeamCollaboration: React.FC<TeamCollaborationProps> = ({
  event
}) => {
  const [message, setMessage] = React.useState('');

  const handleSendMessage = () => {
    // Implementation for sending messages
    console.log('Sending message:', message);
    setMessage('');
  };

  return (
    <Box sx={{ p: 3 }}>
      <Stack spacing={3}>
        <Typography variant="h6">Team Collaboration</Typography>

        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <Paper sx={{ p: 2, height: '60vh', display: 'flex', flexDirection: 'column' }}>
              <Typography variant="subtitle1" gutterBottom>
                Team Chat
              </Typography>
              
              <Box sx={{ flexGrow: 1, overflow: 'auto', mb: 2 }}>
                {/* Chat messages would go here */}
              </Box>

              <Stack direction="row" spacing={2}>
                <TextField
                  fullWidth
                  placeholder="Type a message..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  size="small"
                />
                <Button
                  variant="contained"
                  endIcon={<SendIcon />}
                  onClick={handleSendMessage}
                  disabled={!message.trim()}
                >
                  Send
                </Button>
              </Stack>
            </Paper>
          </Grid>

          <Grid item xs={12} md={4}>
            <Stack spacing={2}>
              <Paper sx={{ p: 2 }}>
                <Typography variant="subtitle1" gutterBottom>
                  Team Members
                </Typography>
                <Stack spacing={2}>
                  {event.staffAssignments.map((staff) => (
                    <Box
                      key={staff.id}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                      }}
                    >
                      <Avatar>{staff.userId}</Avatar>
                      <Box>
                        <Typography variant="subtitle2">
                          {staff.userId}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          {staff.status}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Stack>
              </Paper>

              <Paper sx={{ p: 2 }}>
                <Typography variant="subtitle1" gutterBottom>
                  Shared Files
                </Typography>
                <Stack spacing={1}>
                  {event.eventResources.map((resource) => (
                    <Chip
                      key={resource.id}
                      label={resource.name}
                      variant="outlined"
                      size="small"
                      component="a"
                      href={resource.url}
                      clickable
                    />
                  ))}
                </Stack>
              </Paper>
            </Stack>
          </Grid>
        </Grid>
      </Stack>
    </Box>
  );
};